import React from "react";
import StandardOnboardingWizard from "../features/onboarding/StandardOnboardingWizard";

const Onboarding: React.FC = () => {
  return <StandardOnboardingWizard />;
};

export default Onboarding;
